"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _eachDayOfInterval = _interopRequireDefault(require("date-fns/eachDayOfInterval"));
var _endOfWeek = _interopRequireDefault(require("date-fns/endOfWeek"));
var _startOfWeek = _interopRequireDefault(require("date-fns/startOfWeek"));
var _react = require("react");
var _dateOpts = require("../constants/dateOpts");
var dateOpts = (0, _dateOpts.getDateOpts)('nl');
var useWeekdays = function useWeekdays(options) {
  return (0, _react.useMemo)(function () {
    return (0, _eachDayOfInterval["default"])({
      start: (0, _startOfWeek["default"])(new Date(), options !== null && options !== void 0 ? options : dateOpts),
      end: (0, _endOfWeek["default"])(new Date(), options !== null && options !== void 0 ? options : dateOpts)
    });
  }, [options]);
};
var _default = exports["default"] = useWeekdays;
//# sourceMappingURL=useWeekdays.js.map